import React from 'react';
import { useTranscriptStore } from '../store/transcriptStore';

export const TranscriptionBox: React.FC = () => {
  const { transcript } = useTranscriptStore();

  return (
    <div className="w-full max-w-2xl mx-auto bg-white rounded-lg shadow-md p-4">
      <textarea
        className="w-full h-[60vh] p-4 text-lg text-gray-700 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
        value={transcript}
        readOnly
        placeholder="Your transcribed text will appear here..."
      />
      <div className="mt-4 text-center">
        <p className="text-sm text-gray-500">
          {transcript ? 'Tap the microphone to continue recording' : 'Tap the microphone button to start recording'}
        </p>
      </div>
    </div>
  );
};